export enum DashboardType {
  CO2_DASHBOARD = 'co2',
  EFFICIENCY = 'efficiency',
  OVERVIEW = 'overview',
  BOOKING_DETAILS = 'booking',
  QUALITY = 'quality',
}

export enum DayFilterType {
  THIS_QUARTER = 'this quarter',
  THIS_MONTH = 'this month',
  YEAR_TO_DATE = 'year to date',
  CUSTOM = 'custom',
}

export enum TimeRangeType {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  WEEK = 'WEEK',
  DAY = 'DAY',
}

export enum FilterType {
  COST = 'COST',
  RATE = 'RATE',
  BIDS = 'BIDS',
  BID = 'BID',
  WEIGHT = 'WEIGHT',
  AWB = 'AWB',
}
